/* No backend: code travels in the URL hash. Short keys minimise encoded length. */

export type EmbedTheme = 'light' | 'dark';

export interface SharePayload {
  code: string;
  versions: string[];
  stdin?: string;
  args?: string;
}

interface CompactPayload {
  c: string;
  v: string[];
  i?: string;
  a?: string;
}

export function toCompact(p: SharePayload): CompactPayload {
  const out: CompactPayload = { c: p.code, v: p.versions };
  if (p.stdin) out.i = p.stdin;
  if (p.args) out.a = p.args;
  return out;
}

/** Parse + validate a decoded object; returns null on any shape mismatch so a
 * corrupt/foreign hash never crashes the boot path. */
export function fromCompact(raw: unknown): SharePayload | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  if (typeof o.c !== 'string') return null;
  if (!Array.isArray(o.v) || !o.v.every((x) => typeof x === 'string')) return null;
  const p: SharePayload = { code: o.c, versions: o.v as string[] };
  if (typeof o.i === 'string') p.stdin = o.i;
  if (typeof o.a === 'string') p.args = o.a;
  return p;
}
